import { createBrowserRouter } from "react-router";

import ErrorBoundary from "@/routes/error-boundary";
import RootLayout from "@/routes/root-layout";

/**
 * Route modules are lazily imported so each page lands in its own chunk —
 * the shell stays small, which matters for a PWA's first paint.
 *
 * One route per epic; the paths here are mirrored by `EPICS` in
 * `src/lib/epics.ts`, which drives the nav and the home page.
 *
 * Sign-in and the not-found page are the only routes reachable signed out:
 * everything else, the home page included, reads this account's own data.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    ErrorBoundary,
    children: [
      {
        path: "sign-in",
        lazy: () => import("@/routes/sign-in").then((m) => ({ Component: m.default })),
      },
      {
        // Pathless layout: everything nested here needs a signed-in user, and
        // says so in one place rather than in each page.
        lazy: () => import("@/routes/protected-layout").then((m) => ({ Component: m.default })),
        children: [
          {
            index: true,
            lazy: () => import("@/routes/home").then((m) => ({ Component: m.default })),
          },
          {
            path: "finance",
            lazy: () => import("@/routes/finance").then((m) => ({ Component: m.default })),
          },
          {
            path: "expiry",
            lazy: () => import("@/routes/expiry").then((m) => ({ Component: m.default })),
          },
          {
            path: "prices",
            lazy: () => import("@/routes/prices").then((m) => ({ Component: m.default })),
          },
        ],
      },
      {
        path: "*",
        lazy: () => import("@/routes/not-found").then((m) => ({ Component: m.default })),
      },
    ],
  },
]);
